import capitalize from "lodash.capitalize"

export const ACTIVE = "ACTIVE"
export const HOLD = "HOLD"

const ScheduleStatusEnum = {
  [ACTIVE]: ACTIVE,
  [HOLD]: HOLD
}

const ScheduleStatusEnumKeys = Object.keys(ScheduleStatusEnum)

const ScheduleStatusEnumOptions = ScheduleStatusEnumKeys
  .map(value => ({
    label: capitalize(value),
    value
  }))

export {
  ScheduleStatusEnumKeys,
  ScheduleStatusEnumOptions
}

export default ScheduleStatusEnum
